import { makeStyles } from "@material-ui/core/styles";
// import { preDefinedThemeColor } from "./preDefinedColor";
// const preDefinedColor = preDefinedThemeColor;

export const useStyles = makeStyles((theme) => ({
  quizAdviceMessage:{
    
  },
  root: {
    fontFamily: "Now",
  },
  cardContentWrapper: {
    overflow: "auto",
  },
  title: {
    fontFamily: "Now",
    fontWeight: 700,
    marginBottom: "0.25em",
    fontSize: 20,
  },
  secondaryTitle: {
    fontSize: "1.1em",
    color: "#AEB2BA",
  },
  subTitle: {
    color: "rgb(175,179,187)",
    display: "block",
    fontSize: "0.65em",
    fontWeight: 300,
  },
  headerTitle: {
    fontWeight: 500,
    fontSize: 18,
    color: "rgb(36,42,56)",
  },
  contentDesc: {
    fontSize: 16,
    color: "rgb(131,131,131)",
  },
  mediaWrapper: {
    marginTop: 30,
    position: "relative",
    display: "flex",
    justifyContent: "center",
  },
  mediaWrapperLoader: {
    position: "absolute",
    left: "50%",
    top: "50%",
  },
  message: {
    fontWeight: 500,
    fontSize: "16px",
    color: "rgb(36,42,56)",
    margin: theme.spacing(3, 0),
    textAlign: "center",
    [theme.breakpoints.up("md")]: {
      margin: theme.spacing(6, 0),
    },
  },
  contentDetailsWrapper: {
    padding: theme.spacing(5, 3),
    [theme.breakpoints.up("md")]: {
      padding: theme.spacing(8, 3),
      maxWidth: "80%",
      margin: "auto",
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(5, 2),
      // maxWidth: "80%",
      // margin: "auto",
    },
  },
  headerDate: {
    textAlign: "right",
    color: "rgb(175 179 187)",
    marginBottom: theme.spacing(2.5),
    fontSize: "1.2em",
    fontWeight: 400,
  },
  tabs: {
    padding: 0,
    "& .MuiTab-root": {
      minWidth: "auto",
      padding: "0",
      margin: "0 20px 0 0",
      textTransform: "capitalize",
      fontSize: "1.3em",
    },
    "& .Mui-selected .MuiTab-wrapper": {
      color: "rgb(36,42,56)",
    },
    "& .MuiTab-wrapper": {
      color: "rgb(143,143,143)",
    },
    "& .MuiTabs-indicator": {
      height: "3px",
    },
  },
  tabPanel: {
    padding: 30,
    backgroundColor: "#F1F2F6",
    "& > .MuiBox-root, & > .MuiPaper-root": {
      margin: theme.spacing(0, 0),
      padding: 0,
      backgroundColor: "#FFFFFF",
    },
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(1, 1),
    },
  },
  cardContent: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: theme.spacing(0, 0, 0),
    "&:last-child": {
      padding: theme.spacing(0, 0, 0),
    },
  },
  cardContentBody: {
    padding: 30,
    [theme.breakpoints.down("sm")]: {
      padding: theme.spacing(3, 1),
    },
  },
  cardContentFooter: {
    padding: 30,
  },
  actionLabel: {
    fontSize: 12,
    color: "rgba(193,193,193, 1)",
    marginBottom: 20,
  },
  primaryButtonXl: {
    borderRadius: `${theme.spacing(3)}px !important`,
    padding: theme.spacing(1, 3),
    fontSize: "1.275rem",
    height: "auto",
  },
  quizWrapper: {},
  quizTitle: {
    fontSize: 24,
    fontWeight: 500,
  },
  answerStatus: {
    fontSize: 20,
    fontWeight: 500,
  },
  quizMessage: {
    fontSize: 16,
    fontWeight: 500,
    marginTop: theme.spacing(2),
  },
  quizStartTime: {
    fontSize: 12,
    margin: theme.spacing(2, 0),
  },
  quizQuestionTitle: {
    fontSize: 15,
    color: "rgba(131,131,131, 1)",
    marginBottom: 10,
  },
  quizQuestionText: {
    fontSize: 18,
    fontWeight: 500,
    marginBottom: 10,
  },
  quizOptions: {
    fontSize: 16,
  },
  quizOption: {
    width: "100%",
    display: "flex",
    alignItems: "start",
    "& .MuiRadio-colorPrimary.Mui-checked.Mui-disabled": {
      color: theme.palette.primary.light,
    },
  },
  quizOptionText: {
    padding: theme.spacing(1, 0),
  },
  spacer: {
    margin: theme.spacing(4, 3.75),
  },
  quoteWrapper: {
    color: "rgba(52, 52, 52, 1)",
  },
  quote: {
    fontSize: 20,
    position: "relative",
    paddingLeft: 30,
  },
  quoteSubText: {
    fontSize: 15,
    marginTop: theme.spacing(2),
    color: "rgba(147, 147, 147, 1)",
    marginLeft: 32,
  },
  quoteIcon: {
    color: "rgba(12, 12, 12, 1)",
    position: "absolute",
    left: 0,
    top: -5,
  },
  completeMessage: {
    // marginTop: theme.spacing(4)
    "& a": {
      color: "rgb(51, 136, 255)",
    },
  },
  completeMessageTitle: {
    fontSize: 24,
    fontWeight: 500,
    textAlign: "center",
    marginBottom: theme.spacing(3),
  },
  completeMessageDesc: {
    fontSize: 16,
    textAlign: "center",
  },
  customRadio: {
    "& .MuiSvgIcon-root": {
      // fontSize: 20,
    },
  },
  currectAnswer: {
    "& .MuiSvgIcon-root": {
      fill: theme.palette.success.dark,
    },
  },
  inCorrectAnswer: {
    "& .MuiSvgIcon-root": {
      fill: theme.palette.error.dark,
    },
  },
  quizAdvice: {
    marginTop: 40,
  },
  praisoPlayer: {
    maxWidth: "100%",
    height: "auto !important",
    width: "auto !important",
    [theme.breakpoints.up("md")]: {
      minHeight: "360px !important",
      minWidth: "640px !important",
    },
  },
}));
